import React, { useState } from "react";
import "./active.css";
import axios from "../../../../axios";
import { useNavigate } from 'react-router-dom';

const Deactivate = ({ assessmentId, onChange }) => {
  const navigate = useNavigate();
  const [isInProgress, setIsInProgress] = useState(false);
  const handleDeactivate = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.put(
        `/api/v1/assessment/updateStatus/${assessmentId}`,
        {
          status: "draft",
        }
      );

      res && navigate("/PublishedAssessment");
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };
  return (
    <div className="published_Deative_transprant_body">
      <div className="published_Deative_preview_container">
        <img
          className="deactive_closeBtn"
          src="/images/cross-circle3.svg"
          alt=""
          onClick={(e) => onChange(false)}
        />
        <div className="col-12 deactivate_msg">
          Are you sure you want to deactivate this assessment? Any student
          attempting the assessment will not be able to view it.
        </div>
        <div className="row col-12 publish_deactive_btnBox">
          <button
            disabled={isInProgress}
            onClick={handleDeactivate}
            className="btn col-sm-5 my-1 deactive_sure_btn"
          >
            Yes
          </button>

          <button
            disabled={isInProgress}
            className="btn col-sm-5 my-1  deactive_sure_btn"
            onClick={(e) => onChange(false)}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default Deactivate;
